/**
 * Gets an API based on an identifier.
 * @param identifier - API identifier.
 * @returns API or null if not found.
 */
export function getAPI<T>(identifier: string): T | null {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!window.SYDLE?.api?.[identifier]) {
    return null;
  }

  return window.SYDLE?.api?.[identifier] as T;
}
